import React from 'react';

export default class Page5 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt people">
                                    <div className="innerpadding">


                                        <div className="ilead-contentarea">
                                            <div className="desktop ilead-model">
                                                <table className="ilead_v_sport " border="0" cellPadding="0"
                                                       cellSpacing="0" width="100%">
                                                    <tbody>
                                                    <tr>
                                                        <th className="green_curve" align="left" valign="top"
                                                            width="20%">Area
                                                        </th>
                                                        <th className=" green_curve1" align="left" valign="top"
                                                            width="70%">Explanation
                                                        </th>

                                                    </tr>


                                                    <tr>
                                                        <td className="darkgreen ilead_left" align="center"
                                                            valign="top" width="15%"><img
                                                            src={require('@images/commit-imag.png')}
                                                            style={{margin: 'auto',paddingTop: '60px',paddingLeft:'3px'}}
                                                            className="tableimage"/>
                                                        </td>
                                                        <td className="darkgreen" align="left" valign="top"
                                                            width="70%"><span className="subtiltereg"
                                                                              style={{fontWeight: '600'}}>Why are team members committed to one team and not another?</span>
                                                            <div className="paraspace"><p
                                                                style={{paddingTop:'10px'}}>Commitment is simple.
                                                                It boils down to whether your team members:</p>
                                                            </div>

                                                            <ul className="greenbullet-list">
                                                                <li>Accept and agree with what the team is
                                                                    doing.
                                                                </li>
                                                                <li>Accept and agree how the team is doing what
                                                                    it needs to do.
                                                                </li>
                                                                <li>Are willing to make an effort on behalf of
                                                                    the team.
                                                                </li>
                                                                <li className="list-bottom-pad">Have the desire
                                                                    to remain a team member – what’s in it for
                                                                    them?
                                                                </li>

                                                            </ul>
                                                            <p>Getting all the previous 8 areas correct should
                                                                leave your team members feeling motivated,
                                                                valued and as though they’re genuinely
                                                                working towards achieving something of value.
                                                                All this adds up to a sense of commitment to the
                                                                team because its members will, often
                                                                unconsciously, weigh up whether it’s of benefit
                                                                to them to continue being part of it, or whether
                                                                it’s become something they resent.</p>

                                                        </td>
                                                    </tr>
                                                    </tbody>
                                                </table>
                                            </div>

                                            <div className="mobile ilead-model">
                                                <table className="ilead_v_sport " border="0" cellPadding="0"
                                                       cellSpacing="0" width="100%">
                                                    <tbody>
                                                    <tr>
                                                        <th className="green_curve" align="left" valign="top"
                                                            width="50%">Area
                                                        </th>
                                                        <th className=" green_curve1" align="left" valign="top"
                                                            width="50%">Explanation
                                                        </th>

                                                    </tr>


                                                    <tr>
                                                        <td className="darkgreen ilead_left" align="center"
                                                            valign="top" width="50%"><img
                                                            src={require('@images/commit-imag.png')}
                                                            style={{margin: 'auto',paddingTop: '60px',paddingLeft:'3px'}}
                                                            className="tableimage"/>
                                                        </td>
                                                        <td className="darkgreen" align="left" valign="top"
                                                            width="50%"><span className="subtiltereg"
                                                                              style={{fontWeight: '600'}}>Why are team members committed to one team and not another?</span>
                                                            <div className="paraspace"><p
                                                                style={{paddingTop:'10px'}}>Commitment is simple.
                                                                It boils down to whether your team members:</p>
                                                            </div>

                                                            <ul className="greenbullet-list">
                                                                <li>Accept and agree with what the team is
                                                                    doing.
                                                                </li>
                                                                <li>Accept and agree how the team is doing what
                                                                    it needs to do.
                                                                </li>
                                                                <li>Are willing to make an effort on behalf of
                                                                    the team.
                                                                </li>
                                                                <li className="list-bottom-pad">Have the desire
                                                                    to remain a team member – what’s in it for
                                                                    them?
                                                                </li>

                                                            </ul>
                                                            <p>Getting all the previous 8 areas correct should
                                                                leave your team members feeling motivated,
                                                                valued and as though they’re genuinely
                                                                working towards achieving something of value.
                                                                All this adds up to a sense of commitment to the
                                                                team because its members will, often
                                                                unconsciously, weigh up whether it’s of benefit
                                                                to them to continue being part of it, or whether
                                                                it’s become something they resent.</p>

                                                        </td>
                                                    </tr>
                                                    </tbody>
                                                </table>
                                            </div>

                                            <div className="circle_title">
<span className="heading">
<img className="heading_image" src={require('@images/browndot.jpg')}/>
</span>
                                                <span
                                                    className="heading">PRACTICAL GUIDE TO TEAM ACTIVITIES</span>
                                            </div>

                                            <div className="desktop ilead-model">
                                                <table border="0" cellPadding="0" cellSpacing="0" width="100%">
                                                    <tbody>
                                                    <tr>
                                                        <td align="left" valign="top" width="15%"><img
                                                            src={require('@images/clear-team-objective.png')}
                                                            align="center" className="tableimage"
                                                            style={{paddingBottom: '12px'}}/>
                                                        </td>
                                                        <td align="left" valign="top" style={{paddingLeft:'20px'}}>
                                                            <div className="border_subtitle">Clear team
                                                                objective
                                                            </div>
                                                            <p>If you have an overall objective, or mission, put
                                                                this to the group and explain why it is
                                                                important for you and for the organisation. Then
                                                                ask the
                                                                team to discuss their perceptions and
                                                                understanding of what needs to be achieved. It
                                                                is critical at this early stage that each member
                                                                is absolutely
                                                                certain about what needs to be achieved, why and
                                                                for what benefit to the organisation, the team
                                                                and themselves. Once all this is understood, you
                                                                can throw the discussion open so that they can
                                                                identify specifics.</p>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td align="left" valign="top" width="15%"><img
                                                            src={require('@images/recognising_image.png')}
                                                            align="center" className="tableimage"/>
                                                        </td>
                                                        <td align="left" valign="top" style={{paddingLeft:'20px'}}>
                                                            <div className="border_subtitle">Recognising
                                                                expertise
                                                            </div>
                                                            <div className="paraspace"><p>An important way of
                                                                creating team identity is making sure that every
                                                                member understands:</p></div>
                                                            <ul className="greenbullet-list">
                                                                <li>Why they have been selected as a team
                                                                    member.
                                                                </li>
                                                                <li>The role they are expected to play; that is,
                                                                    what skills, knowledge, experience or
                                                                    attitude they bring, which is of value to
                                                                    the team.
                                                                </li>
                                                                <li className="list-bottom-pad">The expertise
                                                                    other team members bring. This helps
                                                                    individuals develop mutual trust.
                                                                </li>


                                                            </ul>
                                                            <p>In doing this, be careful not to overplay or
                                                                exaggerate people’s expertise because if they
                                                                subsequently fail to live up to your ‘PR’ you’ll
                                                                also lose credibility! You may also have
                                                                inexperienced people on your team – encourage
                                                                other members to identify learning opportunities
                                                                for their new colleagues. This may also help to
                                                                reduce anxiety about potential new people
                                                                joining the team.</p>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td align="left" valign="top" width="10%"><img
                                                            src={require('@images/team-img1.png')}
                                                            align="center" className="tableimage"/>
                                                        </td>
                                                        <td align="left" valign="top" style={{paddingLeft:'20px'}}>
                                                            <div className="border_subtitle">Team values</div>
                                                            <div className="paraspace"><p>Try asking your team
                                                                to debate and agree key questions about how they
                                                                will work together, such as:</p></div>
                                                            <ul className="greenbullet-list">
                                                                <li>What is the best way for the team to
                                                                    communicate? Is it face-to-face meetings?
                                                                    Teleconferences? Emails? A mixture? What
                                                                    type of things need to be communicated? How
                                                                    much communication is too much? Or too
                                                                    little?
                                                                </li>
                                                            </ul>
                                                        </td>
                                                    </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                            <div className="mobile ilead-model">
                                                <table border="0" cellPadding="0" cellSpacing="0" width="100%">
                                                    <tbody>
                                                    <tr>
                                                        <td align="left" valign="top" width="30%"><img
                                                            src={require('@images/clear-team-objective.png')}
                                                            align="center" className="tableimage"
                                                            style={{paddingBottom: '12px'}}/>
                                                        </td>
                                                        <td align="left" valign="top" style={{paddingLeft:'20px'}}>
                                                            <div className="border_subtitle">Clear team
                                                                objective
                                                            </div>
                                                            <p>If you have an overall objective, or mission, put
                                                                this to the group and explain why it is
                                                                important for you and for the organisation. Then
                                                                ask the
                                                                team to discuss their perceptions and
                                                                understanding of what needs to be achieved. It
                                                                is critical at this early stage that each member
                                                                is absolutely
                                                                certain about what needs to be achieved, why and
                                                                for what benefit to the organisation, the team
                                                                and themselves. Once all this is understood, you
                                                                can throw the discussion open so that they can
                                                                identify specifics.</p>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td align="left" valign="top" width="30%"><img
                                                            src={require('@images/recognising_image.png')}
                                                            align="center" className="tableimage"/>
                                                        </td>
                                                        <td align="left" valign="top" style={{paddingLeft:'20px'}}>
                                                            <div className="border_subtitle">Recognising
                                                                expertise
                                                            </div>
                                                            <div className="paraspace"><p>An important way of
                                                                creating team identity is making sure that every
                                                                member understands:</p></div>
                                                            <ul className="greenbullet-list">
                                                                <li>Why they have been selected as a team
                                                                    member.
                                                                </li>
                                                                <li>The role they are expected to play; that is,
                                                                    what skills, knowledge, experience or
                                                                    attitude they bring, which is of value to
                                                                    the team.
                                                                </li>
                                                                <li className="list-bottom-pad">The expertise
                                                                    other team members bring. This helps
                                                                    individuals develop mutual trust.
                                                                </li>


                                                            </ul>
                                                            <p>In doing this, be careful not to overplay or
                                                                exaggerate people’s expertise because if they
                                                                subsequently fail to live up to your ‘PR’ you’ll
                                                                also lose credibility! You may also have
                                                                inexperienced people on your team – encourage
                                                                other members to identify learning opportunities
                                                                for their new colleagues. This may also help to
                                                                reduce anxiety about potential new people
                                                                joining the team.</p>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td align="left" valign="top" width="30%"><img
                                                            src={require('@images/team-img1.png')}
                                                            align="center" className="tableimage"/>
                                                        </td>
                                                        <td align="left" valign="top" style={{paddingLeft:'20px'}}>
                                                            <div className="border_subtitle">Team values</div>
                                                            <div className="paraspace"><p>Try asking your team
                                                                to debate and agree key questions about how they
                                                                will work together, such as:</p></div>
                                                            <ul className="greenbullet-list">
                                                                <li>What is the best way for the team to
                                                                    communicate? Is it face-to-face meetings?
                                                                    Teleconferences? Emails? A mixture? What
                                                                    type of things need to be communicated? How
                                                                    much communication is too much? Or too
                                                                    little?
                                                                </li>
                                                            </ul>
                                                        </td>
                                                    </tr>
                                                    </tbody>
                                                </table>
                                            </div>

                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page4')}
                                                    className="button-next-previous-done">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page6')}
                                                    className="button-next-previous-done">Next &gt;&gt;</div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>


                    </div>
                </div>
            </div>
        </div>;
    ;
    }
    }